// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var NumberType_Enum;
(function (NumberType_Enum) {
    NumberType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    NumberType_Enum["SMS"] = "SMS";
    NumberType_Enum["FAX"] = "FAX";
    NumberType_Enum["VOICE"] = "VOICE";
})(NumberType_Enum || (NumberType_Enum = {}));
export var NumberType_Enum_index;
(function (NumberType_Enum_index) {
    NumberType_Enum_index[NumberType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    NumberType_Enum_index[NumberType_Enum_index["SMS"] = 1] = "SMS";
    NumberType_Enum_index[NumberType_Enum_index["FAX"] = 2] = "FAX";
    NumberType_Enum_index[NumberType_Enum_index["VOICE"] = 3] = "VOICE";
})(NumberType_Enum_index || (NumberType_Enum_index = {}));
export const CommPhoneNumberService = {
    GetDefaultPhoneRecord(fn, req) {
        return fn(`/comm/phone-number/v1/phone-records/default?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPhoneRecords(fn, req) {
        return fn(`/comm/phone-number/v1/phone-records?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
